import useAppStore from "@/context/store";
import { integrationAutomerge, logout, switchOrg } from "@/services";
import { AppLink } from "@gdesign/applink";
import { isNil, omitBy } from "lodash";

// 非框架提供的业务容器模式下，需要手动初始化，并且设置 origin
// 初始化
const applink = new AppLink();

const env = process.env.NEXT_PUBLIC_DEPLOY_ENV;

const gdPath = `https://gd${env === "prod" ? "" : "-" + env}.huaban.com`;

// eg: huaban.com
applink.popup.setOrigin(gdPath);
export function applinkMerge() {
  return new Promise(async (resolve, reject) => {
    const automergeRet = await integrationAutomerge();

    if (automergeRet.result_type === "SUCCESS") {
      resolve(true);
      return;
    }

    if (automergeRet.err) {
      automergeRet.result_type = "FAIL";
    }

    const mergeEquityModal = applink.open(`/applink/popup/merge-equity`, {
      mode: "iframe",
      props: {
        ...omitBy(automergeRet, isNil),
        design_token: "huaban",
      },
    });
    // 合并成功
    mergeEquityModal.on(
      "success",
      async (data: { orgId: string; taskType: { value: string } }[]) => {
        const orgId = data[0].orgId;
        const res = await switchOrg(orgId);
        if (res.err) {
          return;
        }

        // 关闭弹窗
        mergeEquityModal.emit("close", {});

        resolve(orgId);
      }
    );

    // 合并失败
    mergeEquityModal.on("fail", (err) => {
      console.error(err);
      reject(err);
    });

    // 刷新重试
    mergeEquityModal.on("reload", async () => {
      mergeEquityModal.emit("close", {});
      const res = await applinkMerge();
      if (res) {
        resolve(res);
      }
    });

    mergeEquityModal.on("login-out", () => {
      logout();
      useAppStore.setState({
        user: null,
      });
    });
  });
}

export function applinkColdBoot() {
  return new Promise((resolve) => {
    const coldBootModal = applink.open("/applink/popup/cold-bootstrap", {
      mode: "iframe",
      props: {
        mask: true,
        design_token: "huaban",
      },
    });

    coldBootModal.on("success", async (data) => {
      if (data?.[0]) {
        await switchOrg(data[0]);
        // 关闭弹窗
        coldBootModal.emit("close", {});
        resolve(true);
      }
    });

    coldBootModal.on("login-out", () => {
      logout();
      useAppStore.setState({
        user: null,
      });
    });
  });
}
